// src/components/RutaPrivada.jsx
import { useAuth } from '../../context/AuthContext';
import { Navigate } from 'react-router-dom';
import { ModalCarga } from '../ModalCarga/ModalCarga';

export const RutaPrivada = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <ModalCarga />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};
